import type { MeritFilter } from "./types";

type IsActive = (shouldBeActive: boolean) => MeritFilter;

export const isActive: IsActive = shouldBeActive => merit =>
  shouldBeActive ? merit.active === true : merit.active !== true;
